const imp = () => import(/* webpackChunkName: "loadSprite_app_surface"*/  "../sprite/loadSprite_app_surface");

const loadMap_app_surface: { [key: string]: () => Promise<any> } = {
  "Icon-@My-new-feedback": imp,
  "Icon-Approval-process": imp,
  "Icon-Business-form": imp,
  "Icon-CRM-statistics": imp,
  "Icon-Cloud-clothing": imp,
  "Icon-Completed-items": imp,
  "Icon-Concerned-colleagues": imp,
  "Icon-Conference-Room": imp,
  "Icon-Document": imp,
  "Icon-Electronic-signature": imp,
  "Icon-Executive-platform": imp,
  "Icon-Female-head": imp,
  "Icon-Group-portrait": imp,
  "Icon-Invoice-cloud": imp,
  "Icon-inc": imp,
  "Icon-Journalism": imp,
  "Icon-Knowledge-document": imp,
  "Icon-Leave-management": imp,
  "Icon-Male-head-portrait": imp,
  "Icon-Marketing-activities": imp,
  "Icon-Message-center": imp,
  "Icon-Mobile-attendance": imp,
  "Icon-My-subordinates": imp,
  "Icon-New-feedback": imp,
  "Icon-Notice": imp,
  "Icon-Personal-collaboration": imp,
  "Icon-Personnel-contract": imp,
  "Icon-Price": imp,
  "Icon-Push-settings": imp,
  "Icon-Reimbursement": imp,
  "Icon-Statistical-chart": imp,
  "Icon-Statistical-report": imp,
  "Icon-Team-sharing": imp,
  "Icon-Team-work-status": imp,
  "Icon-Telephone": imp,
  "Icon-Unfinished-business": imp,
  "Icon-Unread-items": imp,
  "Icon-Voice-Office": imp,
  "Icon-anonymous": imp,
  "Icon-application": imp,
  "Icon-assets": imp,
  "Icon-authentication": imp,
  "Icon-business-opportunity": imp,
  "Icon-capital": imp,
  "Icon-clue": imp,
  "Icon-competitor": imp,
  "Icon-contacts": imp,
  "Icon-contract": imp,
  "Icon-cooperation": imp,
  "Icon-customer-service": imp,
  "Icon-customer": imp,
  "Icon-daily": imp,
  "Icon-demonstration": imp,
  "Icon-department": imp,
  "Icon-gateway": imp,
  "Icon-global-search": imp,
  "Icon-group": imp,
  "Icon-integrate": imp,
  "Icon-investigation": imp,
  "Icon-label": imp,
  "Icon-mail-list": imp,
  "Icon-mail": imp,
  "Icon-more": imp,
  "Icon-my": imp,
  "Icon-newly-build": imp,
  "Icon-order": imp,
  "Icon-performance-appraisal": imp,
  "Icon-personnel-matters": imp,
  "Icon-picture": imp,
  "Icon-product": imp,
  "Icon-project-management": imp,
  "Icon-quoted-price": imp,
  "Icon-relation": imp,
  "Icon-remind": imp,
  "Icon-report-form": imp,
  "Icon-report": imp,
  "Icon-satisfied": imp,
  "Icon-schedule": imp,
  "Icon-set-up": imp,
  "Icon-share": imp,
  "Icon-signal-communication": imp,
  "Icon-task": imp,
  "Icon-to-grant-authorization": imp,
  "Icon-vehicle": imp,
  "Icon-Background-management-center": imp,
  "Icon-remind04": imp,
  "Icon-menu-color": imp,
  "Icon-Contact-record": imp,
  "Icon-Duplicate-checking": imp,
  "Icon-delete03": imp,
  "Icon-international-waters": imp,
  "Icon-Personal-notes": imp,
  "Icon-Private-arrangements": imp,
  "Icon-Account-security": imp,
  "Icon-upgrade": imp,
  "Icon-Payroll": imp,
  "Icon-position02": imp,
  "Icon-short-message02": imp,
  "Icon-scrm": imp,
  "Icon-market": imp,
  "Icon-WeChat03": imp,
  "Icon-Cloud-reimbursement": imp,
  "Icon-label02": imp,
  "Icon-Cloud-store-o": imp,
  "Icon-Salary-management-o": imp,
  "Icon-To-do-list-o": imp,
  "Icon-ecode-o": imp,
  "Icon-Hrsynchronization-o": imp,
  "Icon-Schedule-meeting-o": imp,
  "Icon-file-management-o": imp,
  "Icon-System-import-and-export-o": imp,
  "Icon-mapping-o": imp,
  "Icon-customerservice2": imp,
  "Icon-Network-IP": imp,
  "Icon-step-on02": imp,
  "Icon-Servicecall-o": imp,
  "Icon-Formengine-o": imp,
  "Icon-Bank-enterprise-direct-link-o": imp,
  "Icon-Archives-integration-o": imp,
  "Icon-Matters-groupchat-o": imp,
  "Icon-My-Personnel-o": imp,
  "Icon-Document-exchange-platform-o": imp,
}

export default loadMap_app_surface;